import { Pipe, PipeTransform } from '@angular/core';
import { Client, TransformGroup } from 'projects/angular-sdk/src/4d-objects';

/**
 * This Pipe is to filter arrays with a BYO filter callback.
 * 
 */
@Pipe({
  name: 'sceneFilter'
})
export class SceneFilterPipe implements PipeTransform {

  constructor(){}

  transform(items: Client[], currentScene: TransformGroup): any {
    if (!items || !currentScene) {
        return items;
    }
    return items.filter(item => item["activeSceneId"] == currentScene.id);
  }

}
